var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 16,
    viewBox: "0 0 34 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3122 1.34506C26.0529 1.09798 25.6423 1.10797 25.3952 1.36736C25.1481 1.62676 25.1581 2.03734 25.4175 2.28442L30.824 7.43425L1.64865 7.43425C1.29041 7.43425 1 7.72466 1 8.0829C1 8.44114 1.29041 8.73155 1.64865 8.73155L30.8243 8.73155L25.4175 13.8817C25.1581 14.1288 25.1481 14.5393 25.3952 14.7987C25.6423 15.0581 26.0529 15.0681 26.3122 14.821L32.7286 8.70928C32.8748 8.57002 32.9613 8.39236 32.988 8.20768C32.9959 8.1673 33 8.12558 33 8.0829C33 8.03992 32.9958 7.99792 32.9878 7.95727C32.9609 7.773 32.8745 7.59578 32.7286 7.45681L26.3122 1.34506Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.c0308d3ffeff48326b5086e25aae818e.svg";
export { ForwardRef as ReactComponent };